import page4Actions from './Page4.actions';

const { Page4ActionConstants } = page4Actions;

const initialState = {
  loading: false,
  userInfo: {},
  projectInfo: [],
  projectScreenshots: [],
  certInfo: [],
  baseCertList: [],
  pubInfo: [],
  baseSkillList: [],
  autoSaveSectionConfig: {
    developerDetail: { status: null, message: null },
    project: { status: null, message: null },
    certifications: { status: null, message: null },
    publications: { status: null, message: null },
    extraDetail: { status: null, message: null }
  },
  certificationUpdated: false,
  publicationUpdated: false,
  projectUpdated: false,
  certificationIndex: null,
  pubIndex: null,
  projectIndex: null,
  searching: false,
  impersonate: false,
  projectData: {},
  certData: {},
  pubData: {}
};

const Page4Reducer = (state = initialState, action) => {
  const { type = '', payload = null } = { ...action };

  switch (type) {
    case Page4ActionConstants.SET_LOADING: {
      if (payload !== null) {
        return { ...state, loading: payload };
      }
      return state;
    }

    case Page4ActionConstants.SET_FINAL_STEP_DATA: {
      if (payload !== null) {
        return { ...state, ...payload };
      }
      return state;
    }

    case Page4ActionConstants.SET_AUTO_SAVE_SECTION_CONFIG: {
      if (payload !== null) {
        return { ...state, autoSaveSectionConfig: { ...payload } };
      }
      return state;
    }

    case Page4ActionConstants.SET_SEARCHING: {
      if (payload !== null) {
        return { ...state, searching: payload };
      }
      return state;
    }
    case Page4ActionConstants.RESET_DATA: {
      return { ...initialState };
    }
    default: {
      return state;
    }
  }
};

export default Page4Reducer;
